import React from 'react'
import { Button } from './styles'

export default ({ onClick, children, className }) => (
  <Button className={className} tag={'button'} onClick={onClick}>{children}</Button>
)
